import Vue from "vue";
import store from "@/store";

import VueModal from "vue-js-modal";
import { Bus } from "@/bus";
import { joinPrivateChannels } from "@/communication";
import { registerServiceWorker } from "@/pushNotification";
import Notifications from "vue-notification";
import VueAnime from "vue-animejs";
import "@/communication";

import "bootstrap/js/dist/tooltip";
import $ from "jquery";
Vue.directive("tooltip", {
  bind: (el, binding) => {
    $(el).tooltip({
      title: binding.value,
      placement: binding.arg,
      trigger: "hover"
    });
  },
  update: (el, binding) => {
    $(el).tooltip("dispose");
    $(el).tooltip({
      title: binding.value,
      placement: binding.arg,
      trigger: "hover"
    });
  },
  unbind: el => {
    $(el).tooltip("dispose");
  }
});

Vue.use(Notifications);
Vue.use(VueModal);
Vue.use(Bus);
Vue.use(VueAnime);

export default new Vue({
  el: "#app",
  store
});

if (store.getters["user/auth"]) {
  joinPrivateChannels();
  registerServiceWorker();
}
